import React from "react";
import PropTypes from "prop-types";
import ChainMonitoringCompact from "./ChainMonitoringCompact";

export default function CardChainMonitoring({ programId, filters }) {
  return <ChainMonitoringCompact programId={programId} filters={filters} />;
}

CardChainMonitoring.propTypes = {
  programId: PropTypes.number,
  filters: PropTypes.object,
};
